import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onBookmarkAddFailed: (isUpdateModal: boolean) => AnalyticsEventPayload = (
	isUpdateModal: boolean,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'failed',
			actionSubject: isUpdateModal ? 'aiSearchBookmarkUpdate' : 'aiSearchBookmarkAddDismiss',
			eventType: 'track',
		};
	} catch (error) {
		logger.error({
			feature: 'bookmarks',
			element: 'container',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onBookmarkAddFailed',
		});
		return {};
	}
};
